import { useEffect, useState } from 'react';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import { loadModuleStrings } from './loadModuleStrings';

/**
 * Довантажує рядки пакетів названих модулів (ключі «модуль» або «модуль/тип») мовою інтерфейсу й повертає лічильник, що зростає після
 * кожного довантаження — залежність для useCallback/useMemo, які читають сховище i18n.
 */
export function useLoadedModuleStrings(keys: readonly string[]): number {
  const lang = useAppSelector(selectLang);
  const [version, setVersion] = useState(0);
  const joined = [...new Set(keys.map((k) => k.split('/')[0]))].filter(Boolean).sort().join(',');
  useEffect(() => {
    let alive = true;
    const list = joined.split(',').filter(Boolean);
    if (!list.length) return undefined;
    void Promise.all(list.map((k) => loadModuleStrings(k, lang).catch(() => undefined))).then(() => { if (alive) setVersion((n) => n + 1); });
    return () => { alive = false; };
  }, [joined, lang]);
  return version;
}
